import React, { useState } from "react";
import "./index.css";
import Logo from "../../../assets/LogoUam.png";
import { useNavigate } from "react-router-dom";
import { sideBarData } from "../../utils/data";
import { BiLogOutCircle, BiMenu} from 'react-icons/bi'
import { motion } from "framer-motion";
import { useUser } from "../../../context/userContext";

const SideBar = ({selected, setSelected}) => {
  const [expanded, setExpaned] = useState(true);
  const navigate = useNavigate();
  const { userData, logoutUser } = useUser();

  const handleLogOut = async () => {
    try{
        logoutUser();
        navigate('/');
    }catch(e){
        console.log(e.message)
    }
}

  const sidebarVariants = {
    true: {
      left : '0'
    },
    false:{
      left : '-60%'
    }
  }

  // Filtrar las opciones según los permisos
  const filteredSideBarData = sideBarData.filter((item) =>
    item.permisos.includes(userData.permisos)
  );



  return (
    <>
      <div className="bars" style={expanded?{left: '60%'}:{left: '5%'}} onClick={()=>setExpaned(!expanded)}>
        <BiMenu />
      </div>
    <motion.div className='sidebar'
    variants={sidebarVariants}
    animate={window.innerWidth<=768?`${expanded}`:''}
    >
      {/* logo */}
      <div className="logo">
        <img src={Logo} alt="logo" />
      </div>

      <div className="menu">
        {filteredSideBarData.map((item, index) => {
          return (
            <div
              className={selected === item.id ? "menuItem active" : "menuItem"}
              key={item.id}
              onClick={() => setSelected(item.id)}
            >
              <item.icon size={24}/>
              <span>{item.heading}</span>
            </div>
          );
        })}
        {/* signoutIcon */}
        <div className="menuItem">
          <BiLogOutCircle size={24} onClick={handleLogOut}/>
        </div>
      </div>
    </motion.div>
    </>
  );
};

export default SideBar;